import { setSearch } from './chatFilterSetters';
const updateSearchFilter = (filters, filterValue) => {
  return setSearch(filterValue, filters);
};
export default updateSearchFilter;